import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Col, Row } from 'reactstrap'
import { IUsersIndicators } from 'src/services/types';
import { fetchUsersIndicators } from 'src/services/users-service';

interface IProps {
    onRefresh?: () => void;
    forceRefresh?: boolean;
    setForceRefresh?: (value: boolean) => void;
}
export const IndicatorsEventNotifications = ({ onRefresh, forceRefresh, setForceRefresh }: IProps) => {

    const [data, setData] = useState<IUsersIndicators>({} as IUsersIndicators);
    const [loading, setLoading] = useState(false);

    const fetchIndicators = async () => {
        setLoading(true);
        const res = await fetchUsersIndicators();
        setLoading(false);
        if (res.result === 'ok') {
        setData(res.data);
        } else {
        console.log('error:', res.message);
        toast(res.message, { type: 'error', autoClose: 3000 });
        }
    }

    const onRefreshData = () => {
        fetchIndicators();
        if (onRefresh) {
            onRefresh();
        }
    }
    
    useEffect(() => {
        fetchIndicators();
    }, []);

    useEffect(() => {
        if (forceRefresh) {
            fetchIndicators();
            if (setForceRefresh) {
                setForceRefresh(false);
            }
        }
    }, [forceRefresh]);

  return (
    <>
        <div className='d-flex justify-content-end mb-2'>
            <button
                type="button"
                className="btn btn-sm btn-soft-primary waves-effect waves-light"
                onClick={onRefreshData}
            >
                {
                    loading ? 
                        <div>
                            <i className="fas fa-spinner fa-spin"></i> Loading...
                        </div>
                    : 
                    <div>
                        <i className="fas fa-sync-alt"></i> Refresh Indicators
                    </div>
                }
            </button>
        </div>
        <Row>
            <Col xs="12" sm="6" md="3" lg="3">
                <div className="card" style={{ backgroundColor: '#f1ece6' }}>
                    <div className="card-body">
                        <h5 className="card-title" style={{fontSize: '14px'}}>Registered users pending review</h5>
                        {
                            loading ? <i className="fas fa-spinner fa-spin"></i>
                            : <h3 className="card-text">{data?.event_notifications?.registered_pending ?? '-'}</h3>
                        }
                    </div>
                </div>
            </Col>
            <Col xs="12" sm="6" md="3" lg="3">
                <div className="card" style={{ backgroundColor: '#e3f2fd' }}>
                    <div className="card-body">
                        <h5 className="card-title" style={{fontSize: '14px'}}>Uploaded WorkID </h5>
                        {
                            loading ? <i className="fas fa-spinner fa-spin"></i>
                            : <h3 className="card-text">{data?.event_notifications?.uploaded_workid ?? '-'}</h3>
                        }
                    </div>
                </div>
            </Col>
            <Col xs="12" sm="6" md="3" lg="3">
                <div className="card" style={{ backgroundColor: '#e3f2fd' }}>
                    <div className="card-body">
                        <h5 className="card-title" style={{fontSize: '14px'}}>PLAID verification successful </h5>
                        {
                            loading ? <i className="fas fa-spinner fa-spin"></i>
                            : <h3 className="card-text">{data?.event_notifications?.verified_plaid_success ?? '-'}</h3>
                        }
                    </div>
                </div>
            </Col>
            <Col xs="12" sm="6" md="3" lg="3">
                <div className="card" style={{ backgroundColor: '#ffe7e2' }}>
                    <div className="card-body">
                        <h5 className="card-title" style={{fontSize: '14px'}}>PLAID verification failed</h5>
                        {
                            loading ? <i className="fas fa-spinner fa-spin"></i>
                            : <h3 className="card-text">{data?.event_notifications?.verified_plaid_failed ?? '-'}</h3>
                        }
                    </div>
                </div>
            </Col>
        </Row>
    </>
  )
}